
var $body,
    $shareButton,
    $menuToggle,
    $header,
    $stickyFooter,
    $stickyAnchor,
    $stickyClose,
    $termToggle,
    $terms,
    $jobFormToggle,
    $jobForm,
    $gvUpload,
    $gvUploadButton,
    $steps,
    $slides,
    $videoSlides,
    $stickyHeader,
    $stickyHeaderAnchor,
    $scrollToForm,
    $stickySidebar,
    $sidebarBottom,
    $imageClickItem,
    $playVideoPopup,
    $videoPopup,
    $closeVideoPopup,
    $tabToggle,
    $gutenbergBlockBtn,
    $historyBackBtns,
    $productsColumn,
    $submenu,
    $toggleLanguage,
    $gvUploadLabel,
    $copyrightNav;


$(document).ready(function($) {

    console.log('%cLinku Novio',"font-size: 2em; font-family: sans-serif; color: white; background-color:#18aaff; padding:4px 8px; border-radius: 4px");

    /* -----------------------------------
     | Get elements
     * ----------------------------------- */
    $body = $('body');
    $shareButton         = $('.js-share');
    $menuToggle          = $('.js-toggle-menu');
    $header              = $('.js-site-header');
    $stickyFooter        = $('.js-sticky-footer');
    $stickyAnchor        = $('.js-toggle-sticky');
    $stickyClose         = $('.js-close-sticky');
    $termToggle          = $('.js-term-toggle');
    $terms               = $('.js-terms');
    $jobForm             = $('.js-job-newsletter');
    $jobFormToggle       = $('.js-toggle-job-newsletter');
    $gvUpload            = $('.ginput_container_fileupload input[type=file]');
    $gvUploadButton      = $('.ginput_container_fileupload + .gfield_description');
    $historyBackBtns     = $('.js-add-history-back');
    $steps               = $('.js-step');
    $slides              = $('.js-infinite-slider');
    $videoSlides         = $('.js-video-slider');
    $stickyHeader        = $('.js-sticky-header');
    $stickyHeaderAnchor  = $('.js-main-start');
    $scrollToForm        = $('.js-scroll-to-form');
    $stickySidebar       = $('.js-sticky-sidebar');
    $sidebarBottom       = $('.js-sticky-sidebar-bottom');
    $imageClickItem      = $('.js-image-click-item');
    $playVideoPopup      = $('.js-open-video-popup');
    $videoPopup          = $('.js-video-popup');
    $closeVideoPopup     = $('.js-close-popup');
    $tabToggle           = $('.js-tab-toggle');
    $gutenbergBlockBtn   = $('.wp-block-button__link');
    $productsColumn      = $('.js-products-column');
    $submenu             = $('.js-toggle-submenu');
    $toggleLanguage      = $('.js-toggle-language');
    $copyrightNav        = $('.js-copyright-nav');


    /* -----------------------------------
     | Startup functions
     * ----------------------------------- */
    toggleStickyFooter();
    toggleStickyHeader();
    stickySidebarResize();
    stickySidebar();
    updateGutenbergBlocKBtns();
    addHistoryBack();
    addProductsColumn($('.b-products__columns.is-open'));
    initLoadMore();
    replaceCookieSettingsAnchor();
    initImageClick();

    /* -----------------------------------
     | Event listeners
     * ----------------------------------- */

    // Gloval click event
    $(window).click(function() {
        $shareButton.removeClass('is-open'); // Close the share button dropdown
    });

    $submenu.on('click', function() {
        if ($(this).hasClass('is-open')) {
            // Close this submenu
            $(this).removeClass('is-open');
            $(this).next().slideUp();
        } else {
            $submenu.next().slideUp();
            $submenu.removeClass('is-open');

            $(this).addClass('is-open');
            $(this).next().slideDown();
        }
    });

    //togle the language switcher option
    $toggleLanguage.on('click', function(){
        $(this).parents('.js-languageswitcher').toggleClass('is-open');
    });

    // Open the share button dropdown
    $shareButton.click(function() {
        event.stopPropagation(); // To prevent double click action (the window click event)
        $(this).toggleClass('is-open');
    });

    // Toggle for the mobile menu and hamburger
    $menuToggle.click(function() {
        $header.toggleClass('has-open-menu');
    });

    // Close sticky footer
    $stickyClose.click(function() {
        $stickyFooter.addClass('is-closed');
    });

    $('.js-open-chat').click(function(e){
      e.preventDefault();

      if ( $('.uiButton').length > 0 ) {
        $('.uiButton').click();
      }
    })

    $tabToggle.click(function(){
       if($(this).hasClass('is-open')) {
           return false;
       }

       var targetIndex = $(this).data('index');
       var $target = $('.js-tab[data-index=' + targetIndex + ']');

        $tabToggle.removeClass('is-open');
       $('.js-tab').removeClass('is-open');
       $(this).addClass('is-open');
       $target.addClass('is-open');
       addProductsColumn($target);

    });

    $termToggle.click(function (e) {
        e.preventDefault();
        var slug = $(this).data('slug');
        var $target = $('.js-term-' + slug);

        $termToggle.addClass('c-button--ghost-primary');
        $(this).removeClass('c-button--ghost-primary');

        if (slug === 'all') {
            $terms.slideDown();
        } else {
            $terms.not($target).slideUp();
            $target.slideDown();
        }
    });

    $jobFormToggle.click(function() {
        $jobForm.slideDown();
        $jobForm[0].scrollIntoView({ block: 'start',  behavior: 'smooth' });
        $jobForm.find('input').focus();
    });

    $scrollToForm.click(function() {
        $('.b-form')[0].scrollIntoView({ block: 'center',  behavior: 'smooth', offsetTop: -500 });
    });


    $steps.on('click', function(){
        $(this).toggleClass('is-open');
        if ($(this).hasClass('is-open')) {
            $(this).next().slideDown();
        } else {
            $(this).next().slideUp();
        }
    });

    // Referal links
    var currUrl = window.location.href;
    $('.js-add-referer').each(function(){
        var $thisLink = $(this);
        var currHref = $thisLink.attr('href');
        var addParamSign = (currHref.indexOf('?') === -1) ? '?':'&';
        var newHref = currHref + addParamSign + 'referralURL=' + encodeURIComponent(currUrl);
        var utmParameters = $thisLink.data('utm');
        if(utmParameters){
            newHref = currHref + addParamSign + utmParameters;
        }
        $thisLink.attr('href', newHref);
    });

    $('.js-update-email-button').on('keyup', function(e){
        var email = $(this).val();
        var link = $(this).next().data('base-link');
        $(this).next().attr('href', (link + '?email=' + encodeURIComponent(email) + '&referralURL=' + encodeURIComponent(currUrl)));

    });

    $slides.owlCarousel({
        'loop': true,
        'autoplay': true,
        'autoplayHoverPause': true,
        'autoplayTimeout': 5000,
        'autoplaySpeed': 5000,
        'slideTransition': 'linear',
        'responsive' : {
            0 : {
                items: 1
            },
            // 576 : {
            //     items: 1
            // },
            768 : {
                items: 2
            },
            // 992 : {
            //     items: 2
            // },
            1212 : {
                items: 3
            },
            2000 : {
                items: 4
            }
        }
    });

    $('.js-infinite-slider-reviews').owlCarousel({
        'loop': true,
        'autoplay': true,
        'autoplayHoverPause': true,
        'autoplayTimeout': 5000,
        'autoplaySpeed': 5000,
        'slideTransition': 'linear',
        'responsive' : {
            0 : {
                items: 1
            },
            576 : {
                items: 2
            },
            // 768 : {
            //     items: 2
            // },
            992 : {
                items: 3
            },
            1500 : {
                items: 4
            },
            2000 : {
                items: 5
            }
        }
    });

    $videoSlides.owlCarousel({
        'loop': true,
        'autoplay': true,
        'autoplayHoverPause': true,
        'autoplaySpeed': 1000,
        'items' : 1,
        'dots': true
    });

    function initImageClick() {
        var $activeItem = $('.js-image-click-item__parent.is-active').first();
        $activeItem.removeClass('is-active');
        handleImageClick($('.js-image-click-item__parent'), $activeItem);
    }

    function handleImageClick($groupItems, $itemParent) {
        var CONTENT_SELECTOR = '.js-image-switcher-content';

        if (!$itemParent.hasClass('is-active')) {
            var $allContent = $(CONTENT_SELECTOR);
            $allContent.stop().slideUp();
            $itemParent.find(CONTENT_SELECTOR).slideDown();

            $groupItems.removeClass('is-active');
            $itemParent.addClass('is-active');
        }
    }

    $imageClickItem.click(function(){
        var groupId = $(this).closest('.js-image-click-item__parent').data('id');
        var $groupItems = $('.js-image-click-item__parent[data-id="'+groupId+'"]');
        var $itemParent = $(this).closest('.js-image-click-item__parent');

        handleImageClick($groupItems, $itemParent);
    });

    // Upload field for gravityform
    $gvUpload.on('change', function() {
        if (this.files[0].name) {
            $gvUploadLabel.attr('data-filename', this.files[0].name);
        }
    });

    $gvUploadButton.on('click', function() {
        $gvUploadLabel = $(this).parent().find('.gfield_description');
        let gvInputField = $(this).parent().find('input[type="file"]')
        gvInputField.trigger('click');
    });

    $playVideoPopup.on('click', function () {
        $videoPopup.addClass('is-open');
        var $iframe = $videoPopup.find('iframe');

        $iframe[0].src += "&autoplay=1";
    });

    $closeVideoPopup.on('click', function () {
        $videoPopup.removeClass('is-open');
        var $iframe = $videoPopup.find('iframe');
        var src = $iframe[0].src;
        src = src.replace("&autoplay=1", "");
        $iframe[0].src = src;
    });


    // Scroll event
    $(window).scroll(function() {
        toggleStickyFooter();
        toggleStickyHeader();
        stickySidebar();
    });

    $( window ).resize(function() {
        stickySidebarResize();
    });
});


/* ------------*
 |  Functions  |
 * ------------*/

function toggleStickyFooter() {
    if ($stickyFooter.length > 0) {
        var screenHeight = $(window).height();
        var anchorOffset = $stickyAnchor.offset().top;
        var scroll = $(window).scrollTop();
        var togglePosition = scroll + screenHeight;
        var check = (anchorOffset > togglePosition);

        if (check) {
            $stickyFooter.addClass('is-visible');
        } else {
            $stickyFooter.removeClass('is-visible');
        }
    }
}

function toggleStickyHeader() {
    if ($stickyHeader.length > 0) {
        var anchorOffset = $stickyHeaderAnchor.offset().top - 320;
        var scroll = $(window).scrollTop();
        var check = (scroll > anchorOffset);

        if (check) {
            $stickyHeader.addClass('is-visible');
        } else {
            $stickyHeader.removeClass('is-visible');
        }
    }
}

function stickySidebarResize() {
    if ($sidebarBottom.length >= 1) {
        var maxOffset = $sidebarBottom.offset().top + $sidebarBottom.height();
        var $parentContainer = $stickySidebar.parent();
        var parentOffset = $parentContainer.offset().top + $parentContainer.height();
        var offset = maxOffset - parentOffset;

        $parentContainer.css('bottom', -offset);
    }
}

function stickySidebar() {
    if ($sidebarBottom.length >= 1) {
        var maxOffset = $sidebarBottom.offset().top + $sidebarBottom.height();
        var topOffset = $(window).scrollTop() + 104 + 48;

        if (maxOffset < topOffset + $stickySidebar.height()) {
            $stickySidebar.addClass('is-stuck-bottom');
        } else {
            $stickySidebar.removeClass('is-stuck-bottom');
        }
    }
}

function updateGutenbergBlocKBtns() {
    $gutenbergBlockBtn.addClass('c-button');
}

function addHistoryBack() {
    $historyBackBtns.click(function() {
        history.back();
    });
}

function addProductsColumn($openTab) {
    $productsColumn.removeAttr('class').addClass('js-products-column col-12 col-lg-' + (3 + $openTab.children().length * 3));
}


function initLoadMore() {
    const ajaxData = {
        action: 'load_blogs',
        current_category: $('.js-load-more').attr('data-category')
    };
    const loadMore = new LoadMore(
        linku_ajax_url,
        null,
        '.js-load-more',
        ajaxData,
        '.js-post-grid'
    );

    loadMore.initClickHandling();
}

function replaceCookieSettingsAnchor() {
    // Target to check to, must be equal to the one filled in the copyrightnav link item.
    let target = "ot-sdk-show-settings";

    // Find the item.
    let item = $copyrightNav.find('a[href="#' + target + '"]');

    // Avoid changing the url
    $(item).click(function(e) {
        e.preventDefault();
    })

    // Add the target as a class so the OneTrust JS triggers the settingsform.
    item.addClass(target);
}


